// @internal
import styled from 'styled-components';

export const StyledSideNavGroupItems = styled.ul`
  width: 100%;
`;
